module.exports = __webpack_public_path__ + "media/images/app/testimonials/trending-2-47a9a84c78911da6e4c39b3c3f851437.webp";